import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import RelectAndIntegrate1Image from "../../../Assets/Images/RelectAndIntegrate1Image.png";
import RelectAndIntegrateIcon from "../../../Assets/Images/RelectAndIntegrateIcon.png"

const RelectAndIntegrate2 = () => {

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 }
        ]
    });


    const styles = StyleSheet.create({
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px",
        },
        image: {
            width: "574px",
            height: "300px",

        },
        content: {
            width: "570px",
            height: "710px",
            display: "flex",
            flexDirection: "column",
            marginTop : "10px"
        },
        imageContainer: {
            width: "574px",
            height: "300px",
        },
        contentDescription: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            fontFamily : "Lato",
            fontWeight : 400,
            fontSize : "12px",
            lineHeight : "18px",
            color : "#245775"
        },
        icon: {
            width: "68px",
            height: "68px"
        },
        text: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "30px",
            color: "#426B88",
            marginBottom : "2px"
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: "#5795B2",
            borderBottom: "1px solid #5795B2"
        },
        title: {
            width: "183px",
            fontSize: "14px",
            fontFamily: "Lato",
            lineHeight: "18px",
            color: "#5795B2",
            fontWeight: 400,

        },
        titlebold: {
            fontWeight: 700
        },
        details: {
            fontSize: "10px",
            fontFamily: "Lato",
            lineHeight: "16px",
            color: "#5795B2",
            fontWeight: 400,
            width: "73px",
            textAlign: "right"

        },
        textbold: {
            fontWeight: 700
        },
        bold : {
            fontWeight : 700
        }
    });
    return (

        <View style={styles.pagewapper}>
            <View style={styles.header}>
                <View style={styles.title}>
                    <Text style={styles.titlebold}>Quadrant Flow</Text>
                    <Text>Life & Leadership Assessment</Text>
                </View>
                <View style={styles.details}>
                    <Text style={styles.textbold}>Rob Murray</Text>
                    <Text>Atlas Real Estate</Text>
                    <Text>Oct 18, 2024</Text>
                </View>
            </View>
            <View style={styles.content}>
                <Text style={styles.text}>REFLECT & INTEGRATE</Text>
                <View style={styles.contentDescription}>
                    <Text>
                    As you review the results of your assessment, take time to answer some of the following questions to deepen your understanding and move your insights toward depth and action. These questions are designed to help you align your results with the life and leadership you want, need, and desire.
                    </Text>
                    <View>
                        <Text style={styles.bold}>Assessments Are a Starting Point, Not the Destination</Text>
                        <Text>Your assessment results provide a snapshot of where you are today, but they are just the beginning of your growth journey. Use them as a foundation for deeper reflection and development.</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Focus on Progress, Not Perfection</Text>
                        <Text>These results highlight both your strengths and areas for growth. Rather than striving for perfection, focus on making continuous progress and learning from the insights provided.</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Integration Is Key</Text>
                        <Text>Information alone doesn’t lead to transformation. It’s how you apply what you’ve learned that creates real change. Work to integrate these insights into your daily actions and decisions.</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Seek Support for Growth</Text>
                        <Text>Growth is a collaborative process. Connect with your coach, consultant, or mentor to help you unpack the results and create a plan for moving forward</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Be Open to Change</Text>
                        <Text>Your leadership and personal growth are ongoing. As you learn from this assessment, stay open to feedback and be willing to make adjustments over time. Flexibility will lead to deeper, lasting development.</Text>
                    </View>
                </View>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default RelectAndIntegrate2